import React, { useEffect, useRef, useState } from "react";
import { AgendaStreamingContext } from "../../../../common/AgendaStreamingContextProvider";
import MessageInfo from "../../../../common/MessageInfo";
import Loader from "../../../../common/Loader";
import { getLabel } from "../../../../data/labels";
import SportSelection from "../../../../common/SportSelection";
import IconsScroller from "../../../../common/IconsScroller";
import { filterBetsByNumberOfOdds, filtraParametriche, getConfiguration, iconCategoryCssClass, iconSportCssClass } from "../../../../data/utils";
import CountrySelector from "../../../../common/CountrySelector";
import Jersey from "../../../../data/jerseys/Jersey";
import Img from "../../../../common/util/Img";
import PrematchContext from "../../../../contexts/PrematchContext";
import { WidgetContext } from "../../../../data/widgets/WidgetContext";
import MainContext from "../../../../contexts/MainContext";
import { getMatchStreamingProps, getStreamingId } from "../../../../data/streaming/streamingUtils";
import StreamingIcon from "../../StreamingIcon";
import { usePoll } from "../../../../data/fetch/useFetch";
import { parseAgendaStreamingData } from "../../../../data/parseAgendaStreamingData";
import { systemCode, xs_languageCode } from "../../../..";
import BetsOddsHeader from "../../../../common/BetsOddsHeader";
import OddsList from "../../../../common/OddsList";
import { CustomCols } from "../../../Live";

function AgendaStreamingSportSelector(props) {
    const [selectedSport,setSelectedSport] = useState(props.data?.find(s => s.eventsCount > 0 ));
    const iconsContainer = useRef(null);

    function changeSport(sportId) {
        setSelectedSport(props.data.find((sport) =>  sport.sportId == sportId ));
    }
 
    const sportButtons = props.data.filter(s => s.eventsCount > 0 ).map((sport, index) => {
        sport.id = sport.sportId;
        sport.descrizione = sport.sportDesc;
        return (
            <React.Fragment key={sport.id}>
                <SportSelection key={sport.id} {...sport} order={index+1} counter={sport.eventsCount} selected={sport.id === selectedSport?.sportId} changeSport={changeSport} />
            </React.Fragment>
        );
    });

    const icoSport = selectedSport && iconSportCssClass(selectedSport.sportId,selectedSport.iconClassSport);

    return (
        <>
            <div className="icons-slider-container-agenda-streaming">
                <div className="slider-icone-sport slider-icone-sport-agenda-streaming horiz-sc icons-container icons-container-no-wrap" ref={iconsContainer}>
                    {sportButtons}
                </div>
                <IconsScroller buttons={sportButtons} iconsContainer={iconsContainer.current} />
            </div>
            <div className="bg-nero bianco titolo-blocco-sport pointer">
                <span className="d-centro-v maiuscolo">
                        <div className={`img-fluid icona-sport margine-dx-mezzo ico-sport ${icoSport} `}></div>
                        {selectedSport.sportDesc}
                </span>
            </div>
            <AgendaStreamingCountrySelector data={props.data} selectedSport={selectedSport} />
        </>
    )
}

function AgendaStreamingCountrySelector(props) {
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);
    const selectedSport = props.data?.find(s => s.sportId == props.selectedSport.sportId )
    const [selectedCountry,setSelectedCountry] = useState(selectedSport?.countriesById?.[0]);
    const [showStarted,setShowStarted] = useState(true);

    useEffect(function(){
        setSelectedCountry(selectedSport?.countriesById?.[0]);
    },[selectedSport.id])

    const countryList = selectedSport.countriesById.filter(c => c.eventsCount > 0 ).map(country => {
        const eventsCount = showStarted? country.eventsCountStarted: country.eventsCountNotStarted;
        return {
            id: country.countryId,
            descrizione: country.countryDesc,
            tournamentsCount: `${eventsCount}/${country.tournamentsCount}`,
            categoryIcon: iconCategoryCssClass(country.sportRef,country.countryId,country.iconClassCountry)
        }
    })
    
    function changeCountry(countryId) {
        setSelectedCountry(selectedSport.countriesById.find((country) =>  country.countryId == countryId ))
    }

    useEffect(function() {
        let firstMatch;
        const hasTournaments =  selectedSport.hasTournaments;
        hasTournaments &&  Object.values(selectedSport.tournamentsById).forEach(t => {
                if ((firstMatch || null) === null) {
                    firstMatch =  Object.values(t.matchesById).find(m => m.ic ==selectedCountry.countryId && !m.strOver);
                }
            });
       
        agendaStreamingContext.setCurrentMatch(firstMatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedCountry]);


    return (
        <>
            <div className="container-slider-icone-agenda-streaming mb-2 overflow-unset has-icons-container-no-wrap">
                <div className="containerElementiDropdown slider-icone-agenda-streaming horiz-sc icons-container icons-container-no-wrap" >
                <div className={`icona-slider-agenda-streaming ${showStarted?'icona-selezionata':''} `} onClick={() => {setShowStarted(true)}} >
                    <figure className="icona-agenda-streaming d-flex justify-content-start flex-row">
                        <StreamingIcon src="assets\img\sport\svg\live-streaming-play.svg" alt="" className="pointer img-tv-streaming"/>
                        <span>{getLabel('live_page.streams_schedule.onair','On air')}</span>
                    </figure>
                </div>
                <div className={`icona-slider-agenda-streaming ${!showStarted?'icona-selezionata':''} `} onClick={() => {setShowStarted(false)}}>
                    <figure className="icona-agenda-streaming d-flex justify-content-start flex-row">
                    <StreamingIcon src="assets\img\sport\icone\tv-streaming.svg" alt="" className="pointer img-tv-streaming"/>
                    <span>{getLabel('live_page.streams_schedule.upcoming','Upcoming events')}</span>
                    </figure>    
                </div>
                </div>
            </div>
            <CountrySelector countryList={countryList} selected={selectedCountry.countryId} changeCountry={changeCountry} showStarted={showStarted} />
            <AgendaStreamingTournaments data={props.data} selectedCountry={selectedCountry}  selectedSport={selectedSport} showStarted={showStarted} />
        </>
       
    )
}

function AgendaStreamingTournaments(props) {
    const mainContext = React.useContext(MainContext);
    const widgetContext = React.useContext(WidgetContext);
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);
    const prematchContext = React.useContext(PrematchContext);
    const showStarted = props.showStarted;
    const tournaments = props.data.find(s => s.sportId == props.selectedSport.sportId)?.tournamentsById?.filter(t => {return t.categoryRef == props.selectedCountry.countryId})
  
    function toggleStreaming(match){
            const streamingProps = getMatchStreamingProps(match);
            const streamingId = streamingProps && getStreamingId(streamingProps[match.id]);
            const streamingInfo = streamingProps && streamingProps[match.id];
            closeWidgetMatch();
            mainContext.toggleStreaming(streamingInfo,streamingId,match.id,'betslip');
    }

    function closeWidgetMatch(){
        widgetContext.setWidget({
            widgetMatchId: null
        });
    }

    const firstTournament = tournaments && Object.values(tournaments).find(t=> t.hasMatchesStarted);
    const icoSport = firstTournament && iconSportCssClass(firstTournament.sportRef,firstTournament.iconClassSport);
    const firstMatchStarted = firstTournament?.matchesById?.find((m) =>  !m.strOver && m.str);
    const customCols = React.useContext(CustomCols);
    let bets = firstMatchStarted?.bets;

    if(bets) {
        bets = filtraParametriche(bets);
        bets = filterBetsByNumberOfOdds(bets, customCols);
    }

    return (
        <>
        {Object.values(tournaments).map((tournament, tIndex) => {
            const icoCategory = iconCategoryCssClass(tournament.sportRef, tournament.categoryRef, tournament.iconClassCountry)
            return ( tournament.hasMatches && 
                <div key={tIndex} className="contenitore-table bg-bianco">
                    <div className={"titolo-competizione-live bg-grigio-scuro pointer bianco bordo-tondo margine-giu-mezzo toggle-nascondi-live "+(props.collapse?'collapsed':'')} data-toggle="collapse" data-target={"#tournament-collapse-" + tournament.tournamentId}>
                        <div className={`img-fluid img-flags margine-dx-mezzo ico-cat ${icoSport}`}></div>
                        <div className={`img-fluid img-flags margine-dx-mezzo ico-cat ${icoCategory}`}></div>
                        <span>{tournament.tournamentDesc}</span>
                    </div>
                    {(showStarted && tournament.hasMatchesStarted) || (!showStarted && tournament.hasMatchesNotStarted)?
                        <div className={!props.collapse?'collapse show':'collapse'} id={"tournament-collapse-" + tournament.tournamentId}>
                            <div className="collapse show" id="paese-calcio-1-aa">
                                <div className="tabellaQuoteIntestazione text_s1 mb-2">
                                    <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                        <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                                    </div>
                                    <div className="tabellaQuoteCampetto">&nbsp;</div>
                                    <div className="tabellaQuoteSquadre d-flex justify-content-center align-items-center"></div>
                                    <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                        {bets && 
                                            <BetsOddsHeader bets={bets} />
                                        }
                                    </div>
                                    <div className="tabellaQuoteStatistiche"></div>
                                    <div className="tabellaQuoteAltre d-flex justify-content-center align-items-center"></div>
                                </div>
                                {Object.values(tournament.matchesById).filter(m => showStarted? m.str != null: m.str == null ).map(function(match,mIndex){
                                    const pointer = prematchContext.section === 'top-match'?match.str:true
            
                                    function changeMatch(){
                                        prematchContext.section === 'top-match'?
                                            toggleStreaming(match)
                                        :
                                        agendaStreamingContext.setCurrentMatch(match)
                                    }
                                    return (!match.strOver && 
                                        <React.Fragment key={match.matchId}>
                                            <div key={"tournament-match-" + match.matchId} className={`tabellaQuoteNew text_s1 mb-2 ${pointer?'pointer':''} ${agendaStreamingContext.currentMatch?.id == match.id?'selezionata':''} `} onClick={pointer && changeMatch}>
                                                <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                                    <div className="tempo-live text-center">
                                                        <span className="fraz-gioco colore-1 margine-dx-mezzo">{match.date.formatted}</span>
                                                    </div>
                                                </div>
                                                <div className="tabellaQuoteCampetto">
                                                    {match.str?
                                                        <Img src="assets/img/sport/svg/live-streaming-play.svg" className="img-fluid" alt="Play streaming" />
                                                    :
                                                    match.strOver?
                                                    <p>{getLabel("live_page.streams_schedule.ended")}</p>
                                                    :
                                                    <p>{getLabel("live_page.streams_schedule.not_started")}</p>
                                                    }
                                                </div>
                                                <div className="tabellaQuoteSquadre">
                                                    <div className="d-flex items-center">
                                                        {match.team2 &&
                                                            <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                                                        }
                                                        <p className="font-weight-bold m-0 text-right" title={match.team1}>
                                                            <span>{match.team1}</span>
                                                        </p>
                                                    </div>
                                                    {match.team2 != null &&
                                                        <>
                                                            <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                                            <div className="d-flex items-center">
                                                                <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                                                                <p className="font-weight-bold m-0 text-left" title={match.team2}>
                                                                    <span>{match.team2}</span>
                                                                </p>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                                <div className="tabellaQuoteContenitoreQuotazioni">
                                                    {match?.bets &&
                                                        <OddsList {...match} />
                                                    }
                                                </div>
                                            </div>
                                            
                                        </React.Fragment>
                                    )
                                })}
                            </div>
                        </div>
                        :
                        <>
                            <div className={!props.collapse?'collapse show':'collapse'} id={"tournament-collapse-" + tournament.tournamentId}>
                                <MessageInfo message={getLabel('live_page.streams_schedule.no_matches')} />
                            </div>
                            
                        </>
                        
                    }
                </div>
            );
        })
        }
        </>
    )
}

export default function AgendaStreamingTemplateV1(props) {
    const conf = getConfiguration();
    const agendaStreamingContext = React.useContext(AgendaStreamingContext);
    const [isLoading, isError, data] = usePoll(conf.api.getAgendaLiveStreaming, 
                    {
                        systemCode,
                        lingua: xs_languageCode,
                        hash: ''
                    }, 
                    (data) =>{
                        if(data) {
                            const parsedData = parseAgendaStreamingData(data);
                            parsedData.forEach(s=> {
                                s.countriesById.sort(function(a, b) {return a.rk - b.rk}); 
                                s.tournamentsById.sort(function(a, b) {return a.rk - b.rk}) 
                            });
                            parsedData.sort(function(a, b) {return a.rk - b.rk});
                            return parsedData;
                        }
                        else{
                            return null;
                        }
                    }
                       
    );

    if (isLoading || isError) {
        return <Loader error={isError} />;
    }

    function messageInfo() {
        return (
            <>
                <div className="bg-nero bianco titolo-blocco-sport pointer">
                    <span className="d-centro-v maiuscolo">
                        <div className={"img-fluid icona-sport margine-dx-mezzo ico-sport icoSport" + props.sportId}></div>
                        {getLabel('live_page.streams_schedule.live_feed')}
                    </span>
                </div>
                <MessageInfo message={getLabel('live_page.streams_schedule.no_matches')} />
            </>
        ) 
    }

    if (!(data) || Object.keys(data).length === 0) {
        return (
            <>
                {messageInfo()}
            </>
        );
    }


    return (
        <div className="agenda-streaming-template-v1" > <AgendaStreamingSportSelector data={data} /></div>
       
    )
}